import { render } from "./UserProfile.html?vue&type=template&id=76d17274&scoped=true&ts=true"
import script from "./UserProfile.ts?vue&type=script&lang=ts"
export * from "./UserProfile.ts?vue&type=script&lang=ts"

import "./UserProfile.css?vue&type=style&index=0&id=76d17274&scoped=true&lang=css"

import exportComponent from "/home/dev/deployment/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d17274"]])

export default __exports__